import type { RefCallback } from "react";
import { type IntersectionOptions, useInView } from "react-intersection-observer";

import { type ITelemetryCustom, sendTelemetryEvent } from "@/lib/telemetry";

export function useTelemetry<TRef extends HTMLElement>({
    viewOptions,
    ...telemetryCustom
}: ITelemetryCustom & { viewOptions?: IntersectionOptions }): RefCallback<TRef> {
    const onChange = viewOptions?.onChange;

    const initialOptions: IntersectionOptions = {
        triggerOnce: true,
        threshold: 0.15,
        ...viewOptions,
        onChange: (isInView, entry) => {
            triggerTelemetryOnInView(isInView, telemetryCustom);
            onChange?.(isInView, entry);
        },
    };

    const { ref } = useInView(initialOptions);

    return ref as RefCallback<TRef>;
    // return ref as unknown as RefObject<TRef>;
}

const triggerTelemetryOnInView = (isInView: boolean, telemetryCustom: ITelemetryCustom) => {
    if (isInView) {
        sendTelemetryEvent(telemetryCustom);
    }
};
